import React from "react";
import { motion } from "framer-motion";
import { 
  DiJavascript1, 
  DiReact, 
  DiNodejs, 
  DiMongodb, 
  DiPython 
} from "react-icons/di";
import { 
  SiTailwindcss, 
  SiExpress, 
  SiFastapi, 
  SiPostgresql, 
  SiAzuredevops, 
  SiNextdotjs,
  SiDocker
} from "react-icons/si";

function Techstack() {
  const skills = [
    { icon: <DiJavascript1 />, label: "JavaScript", color: "text-yellow-400" },
    { icon: <DiReact />, label: "React.js", color: "text-cyan-400" },
    { icon: <SiNextdotjs />, label: "Next.js", color: "text-white" },
    { icon: <DiNodejs />, label: "Node.js", color: "text-green-500" },
    { icon: <SiExpress />, label: "Express.js", color: "text-neutral-300" },
    { icon: <SiTailwindcss />, label: "Tailwind", color: "text-sky-400" },
    { icon: <DiMongodb />, label: "MongoDB", color: "text-green-400" },
    { icon: <SiPostgresql />, label: "PostgreSQL", color: "text-blue-400" },
    { icon: <DiPython />, label: "Python", color: "text-blue-500" },
    { icon: <SiFastapi />, label: "FastAPI", color: "text-teal-400" },
    { icon: <SiAzuredevops />, label: "Azure DevOps", color: "text-blue-600" },
    { icon: <SiDocker />, label: "Docker", color: "text-blue-400" },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6 pt-10">
      {skills.map((skill, index) => (
        <motion.div
          key={index}
          whileHover={{ scale: 1.05, y: -5 }}
          className="glass p-6 rounded-2xl border-white/5 flex flex-col items-center justify-center gap-4 group transition-all duration-300 hover:border-primary/30 hover:shadow-[0_0_20px_rgba(205,95,248,0.1)]"
        >
          <div className={`text-5xl lg:text-6xl ${skill.color} transition-transform group-hover:scale-110`}>
            {skill.icon}
          </div>
          <p className="text-sm font-medium font-mono text-neutral-400 group-hover:text-white transition-colors">
            {skill.label}
          </p>
        </motion.div>
      ))}
    </div>
  );
}

export default Techstack;
